export default (context, inject) => {
  const sentrySendMessage = ({ message, action } = {}) => {
    const Sentry = context?.$sentry || null;
    if (!Sentry) {
      return
    }

    const sentryMessage = [
      Boolean(message) && `Сообщение: ${message}`,
      Boolean(action) && `Место вызова: ${action}`,
    ].filter((t) => !!t).join('\n');
    Sentry.captureException(sentryMessage);
  }
  inject('sentrySendMessage', sentrySendMessage)
}
